import { FC } from "react";

import __ from "web/Layout/Translations";

import SortFilter from "web/Components/Common/SortFilter";
import Title from "web/Components/Common/Title";

import { sortOptions } from "web/constants/toolbar";

import classes from "./header.scss";

type SortOption = typeof sortOptions;

export interface IListingDesktopHeader {
  name: string;
  count?: number;
  sortOptions?: SortOption[];
  isEmpty?: boolean;
}

const ListingDesktopHeader: FC<IListingDesktopHeader> = ({
  name,
  count,
  sortOptions,
  isEmpty = false,
}) => {
  return (
    <header className={classes.root}>
      <Title
        name={name}
        count={count}
        ariaLabelBadge={__("Liczba produktów")}
      />
      {isEmpty ? null : (
        <SortFilter className={classes.sort} options={sortOptions!} darkMode showSortAnchor />
      )}
    </header>
  );
};

export default ListingDesktopHeader;
